import "./ProgressSpinner.scss";

const sizeOptions = {
  xs: "1rem",
  small: "2rem",
  medium: "4rem",
  large: "8rem",
  xl: "12rem",
};

const ProgressSpinner = ({ size = "medium", height, width, ...rest }) => {
  const spinnerSize = {
    height: height || sizeOptions[size] || "100px",
    width: width || sizeOptions[size] || "100px",
  };

  return (
    <div
      data-testid="progressSpinner"
      className="progressSpinner"
      style={spinnerSize}
      {...rest}
    />
  );
};

export default ProgressSpinner;
